import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login'
import Login2 from '@/components/loginPatient'
import List from '@/components/list'
import ImIndex from '@/components/imIndex'
import ImChat from '@/components/imChat'
import Netcall from '@/components/netcall'
import Counselor from '@/components/patientEnd/counselor.vue'
import Psychologist from '@/components/patientEnd/psychologist.vue'
import hospitalList from '@/components/patientEnd/hospitalList.vue'
import Counsulation from '@/components/patientEnd/counsulation.vue'
import HistoryDescs from '@/components/patientEnd/historyDescs.vue'
import SearchResult from '@/components/patientEnd/SearchResult.vue'
import FreeClinic from '@/components/patientEnd/freeClinic.vue'
import HospFilter from '@/components/patientEnd/hospsFilter.vue'
import reconsultHospList from '@/components/patientEnd/reconsultHospList'
import reconsultDocList from '@/components/patientEnd/reconsultDocList'
import DeptFilter from '@/components/patientEnd/deptFilter.vue'
import DoctorInfo from '@/components/patientEnd/doctorInfo'
import Payment from '@/components/patientEnd/payment'
import PaymentFail from '@/components/patientEnd/paymentFailed'
import PaymentSucc from '@/components/patientEnd/paymentSuccess'
import RecordList from '@/components/patientEnd/recordList'
import RecordInfo from '@/components/patientEnd/recordInfo'
import questionnaire from '@/components/patientEnd/questionnaire' // 问卷调查
// 免登陆登记页面（快速注册）
import UserReg from '@/components/patientEnd/userReg'
// 就诊人信息
import patientInform from '@/components/patientEnd/patientInform'
import VideoPlay from '@/components/videoPlay'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/login2',
      name: 'login2',
      component: Login2
    },
    {
      path: '/imIndex',
      name: 'imIndex',
      component: ImIndex
    },
    {
      path: '/imChat',
      name: 'imChat',
      component: ImChat,
      meta: {
        title: '在线咨询'
      }
    },
    {
      path: '/netcall',
      name: 'netcall',
      component: Netcall
    },
    {
      path: '/videoPlay',
      name: 'videoPlay',
      component: VideoPlay
    },
    {
      path: '/list',
      name: 'list',
      component: List
    },
    {
      path: '/',
      redirect: '/userReg'
    },
    {
      path: '/hospitalList',
      name: 'hospitalList',
      component: hospitalList,
      meta: {
        title: '在线咨询'
      }
    },
    {
      path: '/counselor',
      name: 'counselor',
      component: Counselor,
      meta: {
        title: '医生咨询'
      }
    },
    {
      path: '/psychologist',
      name: 'psychologist',
      component: Psychologist,
      meta: {
        title: '心理医生咨询'
      }
    },
    {
      path: '/counsulation',
      name: 'counsulation',
      component: Counsulation,
      meta: {
        title: '医生咨询'
      }
    },
    {
      path: '/historyDescs',
      name: 'historyDescs',
      component: HistoryDescs,
      meta: {
        title: '历史描述'
      }
    },
    {
      path: '/result',
      name: 'result',
      component: SearchResult
    },
    {
      path: '/freeClinic',
      name: 'freeClinic',
      component: FreeClinic
    },
    {
      path: '/hospFilter',
      name: 'hospFilter',
      component: HospFilter
    },
    {
      path: '/reconsultHospList',
      name: 'reconsultHospList',
      component: reconsultHospList,
      meta: {
        title: '在线复诊'
      }
    },
    {
      path: '/reconsultDocList',
      name: 'reconsultDocList',
      component: reconsultDocList,
      meta: {
        title: '在线复诊'
      }
    },
    {
      path: '/deptFilter',
      name: 'deptFilter',
      component: DeptFilter
    },
    {
      path: '/doctorInfo',
      name: 'doctorInfo',
      component: DoctorInfo,
      meta: {
        title: '医生咨询'
      }
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment
    },
    {
      path: '/paymentFail',
      name: 'paymentFail',
      component: PaymentFail
    },
    {
      path: '/paymentSucc',
      name: 'paymentSucc',
      component: PaymentSucc
    },
    {
      path: '/recordList',
      name: 'recordList',
      component: RecordList
    },
    {
      path: '/recordInfo',
      name: 'recordInfo',
      component: RecordInfo
    },
    {
      path: '/userReg',
      name: 'userReg',
      component: UserReg,
      meta: {
        title: ''
      }
    },
    {
      path: '/questionnaire',
      name: 'questionnaire',
      component: questionnaire
    },
    {
      path: '/patientInform',
      name: 'patientInform',
      component: patientInform
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js